import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu";
import { CreationForm, CreationFormTemplate } from "../../components/form/CreationForm";
import { ChangePassFormTemplate, MyAccountFormTemplate } from "../../data-parsing/myAccount/FormTemplate";
import { Admin } from "../../data-parsing/admins/Admin";
import { useMyself } from "../../hooks";
import { User } from "../../data-parsing/users/User";
import { ResponseStatus, StatusContextApi } from "../../context/status";
import { useContext, useEffect, useState } from "react";
import { getKeyByValue } from "../../data-parsing/parseUtils";
import { PrimeReactProvider } from "primereact/api";

import { Calendar } from 'primereact/calendar';
import API from "../../api/api";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api';



const spanishLocale = {
    firstDayOfWeek: 1,
    dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: [
        "enero", "febrero", "marzo", "abril", "mayo", "junio",
        "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ],
    monthNamesShort: [
        "ene", "feb", "mar", "abr", "may", "jun",
        "jul", "ago", "sep", "oct", "nov", "dic"
    ],
    today: "Hoy",
    clear: "Limpiar",
    dateFormat: "dd/mm/yy"
};


addLocale('es', spanishLocale);


// My account debería ser diferente para cada rols
export function MyAccount() {



    // const { myself, updateMyself, updatePassword } = useMyself("");
    const { addMessage } = useContext(StatusContextApi);

    const myUser = sessionStorage.getItem("user");

    const isDoctor = sessionStorage.getItem("doctor") === "true" || false;



    //Gets the info of a doctor
    const { doctorInfo, isFetching, gotError, updateDoctorInfo, updatePassword } = useGetMyselfDoctor(sessionStorage.getItem("userid"))




    const [formData, setFormData] = useState(
        {
            doctorActive: "yes", // In the back 1 means active
            date: null
        })


    //This waits to initialize with values from the server
    useEffect(() => {



        const convertBackendFieldsOfInterest = (rawDoctorInfo) => {
            return {
                //   3 valores: '1'-- > Activo, '0'-- > Inactivo, '-1'
                doctorActive:
                    rawDoctorInfo.activeDr === 1 ?
                        "yes" :
                        rawDoctorInfo.activeDr === 0 ?
                            "no" :
                            "deactivate",
                date: doctorInfo.activeDate ?? null
            }
        }


        if (doctorInfo) {
            setFormData(
                convertBackendFieldsOfInterest(doctorInfo)
            )
        }
    }, [doctorInfo]);



    const handleChangeDoctorInActive = (name, value) => {




        setFormData((prev) => {
            return { ...prev, [name]: value }
        })
    }



    function validateFields(formData) {
        if (formData.get(getKeyByValue(User, User.password)) !== formData.get(getKeyByValue(User, User.passwordVerification))) {
            addMessage(ResponseStatus.ERROR, 5000, "Los valores de contraseña introducidos no coinciden");
            return false;
        }
        return true;
    }





    return <LeftSideMenu active="myAccount">

        <div id="wrapper">

            <div className="container">
                {/* <h3> Debug</h3>
                <p>{JSON.stringify(doctorInfo)}</p> */}

                <div className="row">
                    <div className="col-xs-12">
                        <div className="card-box card-tabs m-t-20">
                            <div className="row">
                                <h4 className="header-title m-r-10 m-t-0 pull-right">MI CUENTA</h4>
                            </div>

                            <div className="row">

                                {doctorInfo &&
                                    <CreationForm createFunction={(data) => updateDoctorInfo(
                                        { ...doctorInfo, ...data })}>

                                        <CreationFormTemplate formTemplate={MyAccountFormTemplate} dataTemplate={Admin}
                                            defaultData={doctorInfo} />

                                        <div className="col-sm-12">
                                            <button
                                                className="btn btn-rounded btn-purple m-b-20 ml-10"><i
                                                    className="far fa-save"></i> Actualizar
                                                Datos
                                            </button>

                                        </div>
                                    </CreationForm>

                                }
                            </div>


                            <div className="row">

                                <CreationForm createFunction={(data) => updatePassword(
                                    { ...doctorInfo, ...data })} v
                                    
                                    alidateForm={validateFields}>

                                    <CreationFormTemplate formTemplate={ChangePassFormTemplate} dataTemplate={Admin} />

                                    <div className="col-sm-12">
                                        <button
                                            className="btn btn-rounded btn-purple m-b-20 ml-10"><i
                                                className="far fa-save"></i> Cambiar
                                            Contraseña
                                        </button>

                                    </div>
                                </CreationForm>
                            </div>



                            {isDoctor &&


                                isFetching ? <span> Cargando</span> : gotError ? <span> Error cargando  datos desde  server</span> :
                                (<>

                                    <div style={{ display: "grid" }}>
                                        <div className="container-group col-sm-12">
                                            <h4 className="m-t-10 m-b-0">Doctor in active</h4>
                                            <hr className="m-t-10" />
                                        </div>

                                        <div style={{ display: "grid", gap: "1em", paddingLeft: "2em" }} >
                                            <label style={{ display: "flex", gap: "0.5em" }} >
                                                <input type="radio"
                                                    name="doctorActive"
                                                    value="yes"
                                                    checked={formData.doctorActive === "yes"}
                                                    onChange={(e) => handleChangeDoctorInActive("doctorActive", "yes")} />
                                                Yes
                                            </label>

                                            <label style={{ display: "flex", gap: "0.5em" }}>
                                                <input type="radio" name="doctorActive" value="no"

                                                    checked={formData.doctorActive === "no"}
                                                    onChange={(e) => handleChangeDoctorInActive("doctorActive", "no")}

                                                />
                                                No
                                            </label>


                                            <div style={{ display: "flex", gap: "2em", alignItems: "center" }}>
                                                <label style={{ display: "flex", gap: "0.5em" }}>
                                                    <input type="radio" name="doctorActive" value="deactivate"
                                                        checked={formData.doctorActive === "deactivate"}
                                                        onChange={(e) => handleChangeDoctorInActive("doctorActive", "deactivate")}

                                                    />
                                                    Deactivate from a date
                                                </label>

                                                {formData.doctorActive === "deactivate" &&
                                                    <PrimeReactProvider value={{ unstyled: false }}>
                                                        <Calendar
                                                            style={{ placeSelf: "center" }}
                                                            value={formData.date ? new Date(formData.date) : new Date()}
                                                            onChange={(e) => handleChangeDoctorInActive("date", e.value)}
                                                            locale="es"
                                                        />
                                                    </PrimeReactProvider>

                                                }
                                            </div>
                                            <button className="btn btn-rounded btn-purple m-b-20 ml-10" onClick={async () => {


                                                const convertFrontendFieldsOfInterest = (formData) => {
                                                    return {
                                                        activeDr:
                                                            formData.doctorActive === "yes" ? 1 :
                                                                formData.doctorActive === "no" ? 0 :
                                                                    -1,

                                                        activeDate: formData.date ?? null
                                                    };
                                                };

                                                addMessage(ResponseStatus.PENDING, 1000, "Actualizando en el servidor... ");

                                                const updatedDoctor = {
                                                    ...doctorInfo,
                                                    ...convertFrontendFieldsOfInterest(formData)
                                                }

                                                const result = await updateDoctorInfo(updatedDoctor)


                                                addMessage(ResponseStatus.RESOLVED, 2000, "Actualizado  ");

                                                // window.alert(` IDK what happened ${JSON.stringify(result)}`)
                                            }}> Actualizar info</button>
                                        </div>
                                    </div>

                                </>
                                )}


                        </div>
                    </div>

                </div>
            </div>

        </div>
    </LeftSideMenu>
}




//Things to do 


// - Call endpoint to get data of myself every time the section of setting the vacations and stuff is rendered. In this way I can set up the initial value of the fields.
// maybe call it useNutritionistData

// - Call endpoint to update 





export function useGetMyselfDoctor(theUserId) {


    const { addMessage } = useContext(StatusContextApi);
    const [data, setIsData] = useState(null)
    const [isFetching, setIsFetching] = useState(true)
    const [gotError, setGotError] = useState(null)

    const apiClient = API.instance()


    const [isSynchronizing, setIsSynchronizing] = useState(false)

    const updateDoctorInfo = async (updatedDoctor) => {


        try {
            const options = {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    Token: sessionStorage.getItem("token"),
                    Userid: sessionStorage.getItem("userid")
                },
                body: JSON.stringify({
                    user_id: theUserId,
                    ...updatedDoctor,
                    token: sessionStorage.getItem("token"),
                    android_id: 0,
                })
            };

            console.log("Will do fetch" , options)
            addMessage(ResponseStatus.PENDING, 1000, "Refrescando...");
            const response = await fetch("https://backend.munchfit.app/webDoctors/updateDoctor", options);

            console.log("Response", response);

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();

            //if ok (then update "data")
            console.log("Doctor update response", data);

            // window.alert(`@alreylz ${JSON.stringify(data)}`);
            addMessage(ResponseStatus.RESOLVED, 1000, "Completado");

            return { success: true, data: data }
        }
        catch (err) {

            console.error(err)
            return { success: false, message: err.message }
        }
        finally {
            setIsSynchronizing(true)

        }

    }


    const updatePassword = async (data) => {
        console.log("updating password", data)
        addMessage(ResponseStatus.PENDING, 1000, "Actualizando en el servidor... ");
        await apiClient.updatePasswordAsNutritionist(data);
        addMessage(ResponseStatus.RESOLVED, 1000, "Contraseña actualizada ");

        console.log("updated password done")
    }


    useEffect(() => {
        setIsFetching(true)
        fetchDoctorData(theUserId)
            .then((remoteData) => {
                setIsData(remoteData)
            }).catch((err) => {
                setGotError(err)
            }).finally(() => {
                setIsFetching(false)
                setIsSynchronizing(false)

            })
    }, [theUserId, isSynchronizing])




    return { doctorInfo: data, isFetching, gotError, updateDoctorInfo, updatePassword }
}





export async function fetchDoctorData(theUserId) {


    try {
        const options = {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                Token: sessionStorage.getItem("token"),
                Userid: sessionStorage.getItem("userid")
            },
            body: JSON.stringify({
                user_id: theUserId,
                token: sessionStorage.getItem("token"),
                android_id: 0,
            })
        };


        // const response = await fetch("https://backend.munchfit.app/webDoctors/updateDoctor", options);
        const response = await fetch("https://backend.munchfit.app/webDoctors/getMyself", options);

        console.log("Response", response);

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Data", data);

        // window.alert(`@alreylz ${JSON.stringify(data)}`);

        return data;

    } catch (err) {
        console.error(err);
        window.alert(`Error: ${err.message}`);
        return err
    }
}

